import { call } from "./api";

export const find = () => {
    return call(client => {
        return client.get(`/player`)
    })
}

export const edit = params => {
    return call(client => {
        return client.post(`/player`, params)
    })
}


// WEBPACK FOOTER //
// ./src/api/player.js